import Constant from '@/const';
import axios from 'axios';

const postLaboratory = async payload => {
  try {
    const response = await axios.post(
      Constant.apiUrl.concat(`/master/laboratory`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default postLaboratory;
